/**
 * Hook-cache keys to invalidate after an auditor-trail citation mutation.
 *
 * Trail citations live under `auditorTrail.steps[].citations` — a cache shape
 * the reperformance/inline optimistic writers don't touch — so the trail
 * mutators POST and then invalidate these keys (the per-attribute-test detail
 * and, when known, its source row) to surface the change. Centralised here so
 * the key strings live in exactly one place.
 */
export function trailCacheKeys(
  auditSessionId: string,
  attributeTestResultId: string,
  sourceRowId?: string,
): string[][] {
  const keys: string[][] = [
    [
      "procedure-session",
      auditSessionId,
      "attribute-test-result",
      attributeTestResultId,
    ],
  ];
  if (sourceRowId) {
    keys.push([
      "procedure-session",
      auditSessionId,
      "source-rows",
      sourceRowId,
    ]);
  }
  return keys;
}
